import { useDataValue } from 'Simple/Data.js'
import useStableValue from 'Logic/useStableValue.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let search_term = useStableValue(
    useDataValue({
      viewPath: props.viewPath,
      context: 'search',
      path: 'term',
    })
  )
  let whole_parent_company = useDataValue({
    viewPath: props.viewPath,
    context: 'search',
    path: 'whole_parent_company',
  })
  let include_leads = useDataValue({
    viewPath: props.viewPath,
    context: 'search',
    path: 'include_leads',
  })
  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })
  let is_new_search_enabled = useDataValue({
    context: 'global',
    path: 'feature_flags.is_new_search_enabled',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      query: search_term,
      whole_parent_company,
      include_leads,
      parent_company_id,
      is_new_search_enabled,
      entity_types: include_leads ? ['PERSON', 'LEAD'] : ['PERSON'],
    },
    pause: search_term.length < 3,
    requestPolicy: 'cache-and-network',
  }
}
